<template>
    <div
        v-if="origin"
        class="handle component-origin"
    >
        <div>
            <p
                class="text"
                style="text-overflow: ellipsis; overflow: hidden; max-height: 30px;"
                :title="data.description || data.type"
            >
                <img
                    v-if="data.icon"
                    :src="data.icon"
                    style="margin-right: 5px; height: 32px; width: 32px; background-color: #ffffff;"
                >
                <span
                    v-else-if="data.representation"
                    class="component-list-icon"
                    v-html="data.representation"
                />
                <span
                    v-else
                    class="component-list-icon"
                    style="width: 8px;"
                />
                <i 
                    class="fa fa-th"
                    style="float: right;"
                />
                {{ data.description || data.type }}
            </p>
            <div class="component-preview-wrapper">
                <component
                    :is="data.type"
                    ref="type"
                    v-bind="{data, origin, tree, container, description}"
                />
            </div>
        </div>
    </div>
    <div 
        v-else 
        class="draggable" 
        :class="{ 'active': selected || isHovered, 'dragged': this.$root.draggedId == data.id, 'edited': selected}"
        :align="(data.style && data.style.align) ? data.style.align : 'center'"
        @mousedown="selectTriggerFocus($event, data.id)" 
        @mouseover.stop="highlightOn" 
        @mouseout.stop="highlightOff"
    >
        <div>
            <table
                ref="contentWrapper"
                width="100%"
                cellspacing="0"
                cellpadding="0"
                :style="{'width': data.style && data.style.width ? data.style.width : '100%'}"
            >
                <tbody>
                    <tr>
                        <td
                            align="center"
                            :style="unbindedStyles"
                        >
                            <component
                                :is="data.type"
                                ref="component"
                                v-bind="{data, origin, tree, container, description}"
                                :triggered="selected"
                                @update="update"
                                @focus="focus"
                                @unfocus="unfocus"
                                @remove="remove"
                                @dragstart="dragstart"
                                @dragend="dragend"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            v-if="(selected || isHovered) && !dragged"
            class="controls"
        >
            <div 
                class="controls-inner" 
                :class="{'columns-controls': data.type === 'columns' || data.type === 'share' || data.type === 'sociallinks'}"
            >
                <span 
                    v-if="data.type === 'columns'"
                    :title="titleLine"
                    class="float-left"
                    style="margin-left: 10px; font-size: 12px; color: #ffffff; line-height: 24px;"
                >
                    {{ data.description }}
                    ({{ data.columns.length }})
                    <span style="margin-left: 10px;">
                        [
                            <span 
                                v-for="(percent, index) in data.columns"
                                :key="index"
                            >
                                {{ Math.round(percent) }} <span v-if="index < data.columns.length-1">/</span>
                            </span>
                        ] %
                    </span>
                </span>
                <span 
                    v-else 
                    class="float-left"
                    style="margin-left: 10px; font-size: 12px; color: #ffffff; line-height: 24px;"
                >
                    {{ data.description }}
                </span>

                <span 
                    v-if="data.type === 'columns'" 
                    style="margin-right: 20px;"
                >
                    <i 
                        v-if="data.columns.length > 1"
                        title="Удалить колонку"
                        class="fa fa-minus control"
                        style="padding: 3px;"
                        @mousedown.stop.prevent=""
                        @click.stop.prevent="removeColumn"
                    />
                    <i 
                        v-else
                        class="fa fa-minus control"
                        style="padding: 3px; opacity: 0.3;"
                        @click.stop.prevent=""
                        @mousedown.stop.prevent=""
                    />
                    <i 
                        v-if="data.columns.length < 4"
                        title="Добавить колонку" 
                        class="fa fa-plus control"
                        style="padding: 3px;"
                        @mousedown.stop.prevent=""
                        @click.stop.prevent="addColumn"
                    />
                    <i 
                        v-else
                        class="fa fa-plus control"
                        style="padding: 3px; opacity: 0.3;"
                        @click.stop.prevent=""
                        @mousedown.stop.prevent=""
                    />
                </span>

                <span 
                    v-if="data.type === 'share' || data.type === 'sociallinks'" 
                    style="margin-right: 20px;"
                >
                    <i 
                        title="Добавить..." 
                        class="fa fa-plus control"
                        style="padding: 3px;"
                        @mousedown.stop.prevent=""
                        @click.stop.prevent="addItem"
                    />
                </span>

                <i 
                    v-if="!locked"
                    class="fa fa-copy control"
                    @mousedown.stop.prevent=""
                    @click.stop.prevent="copy" 
                /><!--
                --><i 
                    v-if="!locked"
                    v-confirm="{
                        okText: 'Да',
                        ok: () => { remove(data.id) },
                        cancelText: 'Отмена',
                        cancel: highlightOff,
                        message: 'Удалить блок?',
                        backdropClose: false, 
                        animation: 'fade',
                    }"
                    class="fa fa-trash control" 
                    @mousedown.stop.prevent=""
                />
            </div>
        </div>
        <block-styles 
            v-if="selected && !dragged && unbindedStylesList.length > 0 && isEdited" 
            :wrapper="$refs.contentWrapper"
            :data="data"
            @change="updateStyles" 
        />
    </div>
</template>


<script>
    import ComponentMixin from './Component.vue'
    import Container from './Container.vue'
    import Columns from './Columns.vue'
    import Picture from './Picture.vue'
    import Spacer from './Spacer.vue'
    import BlockStyles from './BlockStyles.vue'


    export default {
        name: "Block",
        components: {
            'columns': Columns, 'container': Container, 'pic': Picture, 'spacer': Spacer, 'block-styles': BlockStyles
        },
        mixins: [ComponentMixin],
        data: function(){
            return {
                selected: false,
                unbindedStylesList: []
            }
        },
        computed: {
            titleLine: function(){
                let str = this.data.description + ' ('+this.data.columns.length+')';
                str = str + '    [ ';

                for (const [index, percent] of this.data.columns.entries()) {
                    if (index < this.data.columns.length -1) {
                        str+=percent+' / '
                    } 
                    if (index == this.data.columns.length -1) {
                        str+=percent
                    } 
                }

                str = str + ' ] %';

                return str;
            },
            unbindedStyles: function() { 
                let styles = {};
                for (let item of this.unbindedStylesList) {
                    if (this.data.style) {
                        styles[item] = this.data.style[item];
                    }
                }
                if (Object.keys(styles).includes('backgroundImage')) {
                    styles['backgroundPosition'] = 'center center';
                }
                return styles;
            }
        },
        mounted: function() {
                let allowedProperties = [];

                for (let component of this.$root.componentsRegistered) {
                    if (component.type === this.data.type) {
                        if (component.styles){
                            allowedProperties = component.styles;
                        }
                    };
                }

                for (let component of this.$root.componentsAvailable) {
                    if (component.type === this.data.type) {
                        if (component.styles){
                            allowedProperties = component.styles;
                        }
                    };
                }

                if (this.$refs.component) {
                    if (this.$refs.component.$options) {
                        const bindedStyles = this.$refs.component.bindedStyles || [];

                        this.unbindedStylesList = allowedProperties.filter(function(i) {
                            return bindedStyles.indexOf(i) < 0}
                        );
                    }
                }
        },
        methods: {
            selectTriggerFocus: function(event, id) {
                if (this.$refs.component.triggerFocus) {
                    this.$refs.component.triggerFocus(event, id);
                } else {
                    this.triggerFocus(event, id);
                }
            },
            updateStyles: function(data) {
                this.update(this.data.id, {'style': data});
                this.$forceUpdate();
            },
            addItem: function() {
                this.unfocus(this.$root.editorActive);
                this.$refs.component.focus(this.$refs.component.data.id);
                this.$refs.component.enterEditMode();
                this.$refs.component.addItem();
            },
            addColumn: function() {
                let newRatios = [...this.data.columns];
                let tree = this.data.tree;

                while (tree.length < this.data.columns.length) tree.push([]);

                newRatios.push(Math.ceil(100/(newRatios.length+1)));
                this.calculateColumnRatios(newRatios, newRatios.length-1)

                this.$set(this.data, 'columns', newRatios);
                this.update(this.data.id, {'columns': newRatios, 'tree': tree});
            },
            removeColumn: function() {
                let newRatios = [...this.data.columns];
                let tree = [...this.data.tree];

                while (tree.length < this.data.columns.length) tree.pop();

                newRatios.pop();
                this.calculateColumnRatios(newRatios, null);

                this.update(this.data.id, {'columns': newRatios, 'tree': tree});
            },
            calculateColumnRatios: function(newRatios, newIndex) {
                if (newRatios.length == 1) {
                    newRatios[0] = 100;
                    return newRatios;
                }

                for (let [index, item] of newRatios.entries()) {
                    newRatios[index] = Math.round(item);
                }

                let widthsSum = newRatios.reduce(function(a, b) { return a + b; });
                let counter = 0;

                while (newIndex ? widthsSum > 100 : widthsSum < 100){
                    counter++;
                    if (counter > 300) {
                        console.warn('Resize counter value of 300 exceeded');
                        return newRatios;
                    }
                    for (let [index, col] of newRatios.entries()) {
                        if (newIndex !== null) { 
                            if (index != newIndex && col > 15) {
                                newRatios[index] = newRatios[index] - 1;
                            }
                        } else {
                            if (col < 60) {
                                newRatios[index] = newRatios[index] + 1;
                            }
                        }

                        widthsSum = newRatios.reduce(function(a, b) { return a + b; });

                        if ((newIndex && widthsSum <= 100) || (!newIndex && widthsSum >= 100)){
                            break;
                        }
                    }
                }
                return newRatios;
            }
        }
    }
</script>

